import { Drawer } from 'antd';
import { useShallow } from 'zustand/react/shallow';

import { useDetailsDrawerStore } from '../../store';

import { DrawerTitle } from './DrawerTitle';

const DetailsDrawer = () => {
  const { closeDrawer, isDrawerOpen, drawerTitle, drawerContent } =
    useDetailsDrawerStore(
      useShallow((state) => ({
        closeDrawer: state.closeDrawer,
        isDrawerOpen: state.isDrawerOpen,
        drawerTitle: state.drawerTitle,
        drawerContent: state.drawerContent
      }))
    );

  const onClose = () => {
    closeDrawer();
  };

  return (
    <Drawer
      title={<DrawerTitle drawerTitle={drawerTitle} onDrawerClose={onClose} />}
      size={'large'}
      placement={'right'}
      closable={false}
      onClose={onClose}
      closeIcon={true}
      maskClosable={true}
      open={isDrawerOpen}
      key={'DetailsDrawerRight'}
      className={'h-[100vh] rounded-md mt-2.5 p-0'}
      contentWrapperStyle={{
        marginRight: 10,
        marginBottom: 10,
        height: '98vh',
        width: '722px'
      }}
      styles={{
        header: {
          padding: 0
        },
        body: {
          padding: 0,
          overflowX: 'hidden'
        }
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export { DetailsDrawer };
